import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(data.user);
        window.history.replaceState(null, "", "/moderator/dashboard");
        navigate("/moderator/dashboard", { replace: true, state: { user: data.user } });
      } catch {
        navigate("/moderator/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return <div className="min-h-screen grid place-items-center text-sm text-slate-500">Signing you in…</div>;
}
